/* eslint-disable import/no-unresolved */
import React from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import 'lazysizes';
import 'typeface-montserrat';
import 'bootstrap/dist/css/bootstrap.css';
import '@fontsource/nunito';

import Menu from '../../../organisms/v2/Menu';
import BannerPartnership from '../../../organisms/V4/BannerPartnership';
import Footer from '../../../organisms/Footer';
import withDefautlHoc from '../../../_hoc/global';

import withIntl from '../../../../helper/hoc/withIntl';

const JoinPartnership = ({ enPrefix }) => {
	const navigateToFormSignUp = () => {
		let currentUrl = '';
		if (typeof window !== 'undefined') {
			currentUrl = window.location.href;
		}
		if (enPrefix) {
			navigate(`/en/form/signup?fromUrl=${currentUrl}`);
		} else {
			navigate(`/form/signup?lang=id&fromUrl=${currentUrl}`);
		}
	};

	return (
		<>
			<Menu enPrefix={enPrefix} onDemoClick={navigateToFormSignUp} />

			<BannerPartnership />

			<Footer enPrefix={enPrefix} />
		</>
	);
};

JoinPartnership.propTypes = {
	enPrefix: PropTypes.string.isRequired,
};

export default withIntl(withDefautlHoc(JoinPartnership));
